import React from 'react';

export default ({ valores }) => {
  return (
    <div>
      <h3 style={{ marginTop: '30px' }}>Resultado detallado</h3>
      <table>
        <thead>
          <tr>
            <th>Preguntas</th>
            <th>Valor</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>1. Retroalimentación de mi supervisor directo.</td>
            <td>
              {valores.preg1 &&
                valores.preg1.valor === 'Totalmente De acuerdo' && (
                  <span className="preg-green">100%</span>
                )}
              {valores.preg1 &&
                valores.preg1.valor === 'De acuerdo' && (
                  <span className="preg-blue">80%</span>
                )}
              {valores.preg1 &&
                valores.preg1.valor === 'Ni de acuerdo ni en desacuerdo' && (
                  <span className="preg-yellow">60%</span>
                )}
              {valores.preg1 &&
                valores.preg1.valor === 'En desacuerdo' && (
                  <span className="preg-orange">40%</span>
                )}
              {valores.preg1 &&
                valores.preg1.valor === 'Totalmente desacuerdo' && (
                  <span className="preg-red">20%</span>
                )}
            </td>
          </tr>
          <tr>
            <td>2. Relación con mi supervisor directo.</td>
            <td>
              {valores.preg2 &&
                valores.preg2.valor === 'Totalmente De acuerdo' && (
                  <span className="preg-green">100%</span>
                )}
              {valores.preg2 &&
                valores.preg2.valor === 'De acuerdo' && (
                  <span className="preg-blue">80%</span>
                )}
              {valores.preg2 &&
                valores.preg2.valor === 'Ni de acuerdo ni en desacuerdo' && (
                  <span className="preg-yellow">60%</span>
                )}
              {valores.preg2 &&
                valores.preg2.valor === 'En desacuerdo' && (
                  <span className="preg-orange">40%</span>
                )}
              {valores.preg2 &&
                valores.preg2.valor === 'Totalmente desacuerdo' && (
                  <span className="preg-red">20%</span>
                )}
            </td>
          </tr>
          <tr>
            <td>3. Lideres comunican de una clara visión.</td>
            <td>
              {valores.preg3 &&
                valores.preg3.valor === 'Totalmente De acuerdo' && (
                  <span className="preg-green">100%</span>
                )}
              {valores.preg3 &&
                valores.preg3.valor === 'De acuerdo' && (
                  <span className="preg-blue">80%</span>
                )}
              {valores.preg3 &&
                valores.preg3.valor === 'Ni de acuerdo ni en desacuerdo' && (
                  <span className="preg-yellow">60%</span>
                )}
              {valores.preg3 &&
                valores.preg3.valor === 'En desacuerdo' && (
                  <span className="preg-orange">40%</span>
                )}
              {valores.preg3 &&
                valores.preg3.valor === 'Totalmente desacuerdo' && (
                  <span className="preg-red">20%</span>
                )}
            </td>
          </tr>
          <tr>
            <td>4. Reconocimiento por un buen trabajo.</td>
            <td>
              {valores.preg4 &&
                valores.preg4.valor === 'Totalmente De acuerdo' && (
                  <span className="preg-green">100%</span>
                )}
              {valores.preg4 &&
                valores.preg4.valor === 'De acuerdo' && (
                  <span className="preg-blue">80%</span>
                )}
              {valores.preg4 &&
                valores.preg4.valor === 'Ni de acuerdo ni en desacuerdo' && (
                  <span className="preg-yellow">60%</span>
                )}
              {valores.preg4 &&
                valores.preg4.valor === 'En desacuerdo' && (
                  <span className="preg-orange">40%</span>
                )}
              {valores.preg4 &&
                valores.preg4.valor === 'Totalmente desacuerdo' && (
                  <span className="preg-red">20%</span>
                )}
            </td>
          </tr>
          <tr>
            <td>5. Confianza por parte de mi supervisor directo.</td>
            <td>
              {valores.preg5 &&
                valores.preg5.valor === 'Totalmente De acuerdo' && (
                  <span className="preg-green">100%</span>
                )}
              {valores.preg5 &&
                valores.preg5.valor === 'De acuerdo' && (
                  <span className="preg-blue">80%</span>
                )}
              {valores.preg5 &&
                valores.preg5.valor === 'Ni de acuerdo ni en desacuerdo' && (
                  <span className="preg-yellow">60%</span>
                )}
              {valores.preg5 &&
                valores.preg5.valor === 'En desacuerdo' && (
                  <span className="preg-orange">40%</span>
                )}
              {valores.preg5 &&
                valores.preg5.valor === 'Totalmente desacuerdo' && (
                  <span className="preg-red">20%</span>
                )}
            </td>
          </tr>
          <tr>
            <td>6. Autonomía para tomar decisiones.</td>
            <td>
              {valores.preg6 &&
                valores.preg6.valor === 'Totalmente De acuerdo' && (
                  <span className="preg-green">100%</span>
                )}
              {valores.preg6 &&
                valores.preg6.valor === 'De acuerdo' && (
                  <span className="preg-blue">80%</span>
                )}
              {valores.preg6 &&
                valores.preg6.valor === 'Ni de acuerdo ni en desacuerdo' && (
                  <span className="preg-yellow">60%</span>
                )}
              {valores.preg6 &&
                valores.preg6.valor === 'En desacuerdo' && (
                  <span className="preg-orange">40%</span>
                )}
              {valores.preg6 &&
                valores.preg6.valor === 'Totalmente desacuerdo' && (
                  <span className="preg-red">20%</span>
                )}
            </td>
          </tr>
          <tr>
            <td>7. Favoritismo.</td>
            <td>
              {valores.preg7 &&
                valores.preg7.valor === 'Totalmente De acuerdo' && (
                  <span className="preg-green">100%</span>
                )}
              {valores.preg7 &&
                valores.preg7.valor === 'De acuerdo' && (
                  <span className="preg-blue">80%</span>
                )}
              {valores.preg7 &&
                valores.preg7.valor === 'Ni de acuerdo ni en desacuerdo' && (
                  <span className="preg-yellow">60%</span>
                )}
              {valores.preg7 &&
                valores.preg7.valor === 'En desacuerdo' && (
                  <span className="preg-orange">40%</span>
                )}
              {valores.preg7 &&
                valores.preg7.valor === 'Totalmente desacuerdo' && (
                  <span className="preg-red">20%</span>
                )}
            </td>
          </tr>
          <tr>
            <td>8. Involucramiento toma de decisiones.</td>
            <td>
              {valores.preg8 &&
                valores.preg8.valor === 'Totalmente De acuerdo' && (
                  <span className="preg-green">100%</span>
                )}
              {valores.preg8 &&
                valores.preg8.valor === 'De acuerdo' && (
                  <span className="preg-blue">80%</span>
                )}
              {valores.preg8 &&
                valores.preg8.valor === 'Ni de acuerdo ni en desacuerdo' && (
                  <span className="preg-yellow">60%</span>
                )}
              {valores.preg8 &&
                valores.preg8.valor === 'En desacuerdo' && (
                  <span className="preg-orange">40%</span>
                )}
              {valores.preg8 &&
                valores.preg8.valor === 'Totalmente desacuerdo' && (
                  <span className="preg-red">20%</span>
                )}
            </td>
          </tr>
          <tr>
            <td>9. Burocracia.</td>
            <td>
              {valores.preg9 &&
                valores.preg9.valor === 'Totalmente De acuerdo' && (
                  <span className="preg-green">100%</span>
                )}
              {valores.preg9 &&
                valores.preg9.valor === 'De acuerdo' && (
                  <span className="preg-blue">80%</span>
                )}
              {valores.preg9 &&
                valores.preg9.valor === 'Ni de acuerdo ni en desacuerdo' && (
                  <span className="preg-yellow">60%</span>
                )}
              {valores.preg9 &&
                valores.preg9.valor === 'En desacuerdo' && (
                  <span className="preg-orange">40%</span>
                )}
              {valores.preg9 &&
                valores.preg9.valor === 'Totalmente desacuerdo' && (
                  <span className="preg-red">20%</span>
                )}
            </td>
          </tr>
          <tr>
            <td>10. Me siento feliz.</td>
            <td>
              {valores.preg10 &&
                valores.preg10.valor === 'Totalmente De acuerdo' && (
                  <span className="preg-green">100%</span>
                )}
              {valores.preg10 &&
                valores.preg10.valor === 'De acuerdo' && (
                  <span className="preg-blue">80%</span>
                )}
              {valores.preg10 &&
                valores.preg10.valor === 'Ni de acuerdo ni en desacuerdo' && (
                  <span className="preg-yellow">60%</span>
                )}
              {valores.preg10 &&
                valores.preg10.valor === 'En desacuerdo' && (
                  <span className="preg-orange">40%</span>
                )}
              {valores.preg10 &&
                valores.preg10.valor === 'Totalmente desacuerdo' && (
                  <span className="preg-red">20%</span>
                )}
            </td>
          </tr>
          <tr>
            <td>11. Salud.</td>
            <td>
              {valores.preg11 &&
                valores.preg11.valor === 'Totalmente De acuerdo' && (
                  <span className="preg-green">100%</span>
                )}
              {valores.preg11 &&
                valores.preg11.valor === 'De acuerdo' && (
                  <span className="preg-blue">80%</span>
                )}
              {valores.preg11 &&
                valores.preg11.valor === 'Ni de acuerdo ni en desacuerdo' && (
                  <span className="preg-yellow">60%</span>
                )}
              {valores.preg11 &&
                valores.preg11.valor === 'En desacuerdo' && (
                  <span className="preg-orange">40%</span>
                )}
              {valores.preg11 &&
                valores.preg11.valor === 'Totalmente desacuerdo' && (
                  <span className="preg-red">20%</span>
                )}
            </td>
          </tr>
          <tr>
            <td>12. Energía.</td>
            <td>
              {valores.preg12 &&
                valores.preg12.valor === 'Totalmente De acuerdo' && (
                  <span className="preg-green">100%</span>
                )}
              {valores.preg12 &&
                valores.preg12.valor === 'De acuerdo' && (
                  <span className="preg-blue">80%</span>
                )}
              {valores.preg12 &&
                valores.preg12.valor === 'Ni de acuerdo ni en desacuerdo' && (
                  <span className="preg-yellow">60%</span>
                )}
              {valores.preg12 &&
                valores.preg12.valor === 'En desacuerdo' && (
                  <span className="preg-orange">40%</span>
                )}
              {valores.preg12 &&
                valores.preg12.valor === 'Totalmente desacuerdo' && (
                  <span className="preg-red">20%</span>
                )}
            </td>
          </tr>
          <tr>
            <td>13. Opinión acerca de mi mismo.</td>
            <td>
              {valores.preg13 &&
                valores.preg13.valor === 'Totalmente De acuerdo' && (
                  <span className="preg-green">100%</span>
                )}
              {valores.preg13 &&
                valores.preg13.valor === 'De acuerdo' && (
                  <span className="preg-blue">80%</span>
                )}
              {valores.preg13 &&
                valores.preg13.valor === 'Ni de acuerdo ni en desacuerdo' && (
                  <span className="preg-yellow">60%</span>
                )}
              {valores.preg13 &&
                valores.preg13.valor === 'En desacuerdo' && (
                  <span className="preg-orange">40%</span>
                )}
              {valores.preg13 &&
                valores.preg13.valor === 'Totalmente desacuerdo' && (
                  <span className="preg-red">20%</span>
                )}
            </td>
          </tr>
          <tr>
            <td>14. Importancia del trabajo.</td>
            <td>
              {valores.preg14 &&
                valores.preg14.valor === 'Totalmente De acuerdo' && (
                  <span className="preg-green">100%</span>
                )}
              {valores.preg14 &&
                valores.preg14.valor === 'De acuerdo' && (
                  <span className="preg-blue">80%</span>
                )}
              {valores.preg14 &&
                valores.preg14.valor === 'Ni de acuerdo ni en desacuerdo' && (
                  <span className="preg-yellow">60%</span>
                )}
              {valores.preg14 &&
                valores.preg14.valor === 'En desacuerdo' && (
                  <span className="preg-orange">40%</span>
                )}
              {valores.preg14 &&
                valores.preg14.valor === 'Totalmente desacuerdo' && (
                  <span className="preg-red">20%</span>
                )}
            </td>
          </tr>
          <tr>
            <td>
              15. Entiendo cómo mi rol contribuye a logro de los objetivos.
            </td>
            <td>
              {valores.preg15 &&
                valores.preg15.valor === 'Totalmente De acuerdo' && (
                  <span className="preg-green">100%</span>
                )}
              {valores.preg15 &&
                valores.preg15.valor === 'De acuerdo' && (
                  <span className="preg-blue">80%</span>
                )}
              {valores.preg15 &&
                valores.preg15.valor === 'Ni de acuerdo ni en desacuerdo' && (
                  <span className="preg-yellow">60%</span>
                )}
              {valores.preg15 &&
                valores.preg15.valor === 'En desacuerdo' && (
                  <span className="preg-orange">40%</span>
                )}
              {valores.preg15 &&
                valores.preg15.valor === 'Totalmente desacuerdo' && (
                  <span className="preg-red">20%</span>
                )}
            </td>
          </tr>
          <tr>
            <td>16. Satisfacción con el trabajo.</td>
            <td>
              {valores.preg16 &&
                valores.preg16.valor === 'Totalmente De acuerdo' && (
                  <span className="preg-green">100%</span>
                )}
              {valores.preg16 &&
                valores.preg16.valor === 'De acuerdo' && (
                  <span className="preg-blue">80%</span>
                )}
              {valores.preg16 &&
                valores.preg16.valor === 'Ni de acuerdo ni en desacuerdo' && (
                  <span className="preg-yellow">60%</span>
                )}
              {valores.preg16 &&
                valores.preg16.valor === 'En desacuerdo' && (
                  <span className="preg-orange">40%</span>
                )}
              {valores.preg16 &&
                valores.preg16.valor === 'Totalmente desacuerdo' && (
                  <span className="preg-red">20%</span>
                )}
            </td>
          </tr>
          <tr>
            <td>17. Incluido, valorado y aceptado.</td>
            <td>
              {valores.preg17 &&
                valores.preg17.valor === 'Totalmente De acuerdo' && (
                  <span className="preg-green">100%</span>
                )}
              {valores.preg17 &&
                valores.preg17.valor === 'De acuerdo' && (
                  <span className="preg-blue">80%</span>
                )}
              {valores.preg17 &&
                valores.preg17.valor === 'Ni de acuerdo ni en desacuerdo' && (
                  <span className="preg-yellow">60%</span>
                )}
              {valores.preg17 &&
                valores.preg17.valor === 'En desacuerdo' && (
                  <span className="preg-orange">40%</span>
                )}
              {valores.preg17 &&
                valores.preg17.valor === 'Totalmente desacuerdo' && (
                  <span className="preg-red">20%</span>
                )}
            </td>
          </tr>
          <tr>
            <td>
              18. Recomiendo esta empresa como un gran lugar para trabajar.
            </td>
            <td>
              {valores.preg18 &&
                valores.preg18.valor === 'Totalmente De acuerdo' && (
                  <span className="preg-green">100%</span>
                )}
              {valores.preg18 &&
                valores.preg18.valor === 'De acuerdo' && (
                  <span className="preg-blue">80%</span>
                )}
              {valores.preg18 &&
                valores.preg18.valor === 'Ni de acuerdo ni en desacuerdo' && (
                  <span className="preg-yellow">60%</span>
                )}
              {valores.preg18 &&
                valores.preg18.valor === 'En desacuerdo' && (
                  <span className="preg-orange">40%</span>
                )}
              {valores.preg18 &&
                valores.preg18.valor === 'Totalmente desacuerdo' && (
                  <span className="preg-red">20%</span>
                )}
            </td>
          </tr>
          <tr>
            <td>
              19. Orgullo de decirle a la gente que trabajo para mi empresa
            </td>
            <td>
              {valores.preg19 &&
                valores.preg19.valor === 'Totalmente De acuerdo' && (
                  <span className="preg-green">100%</span>
                )}
              {valores.preg19 &&
                valores.preg19.valor === 'De acuerdo' && (
                  <span className="preg-blue">80%</span>
                )}
              {valores.preg19 &&
                valores.preg19.valor === 'Ni de acuerdo ni en desacuerdo' && (
                  <span className="preg-yellow">60%</span>
                )}
              {valores.preg19 &&
                valores.preg19.valor === 'En desacuerdo' && (
                  <span className="preg-orange">40%</span>
                )}
              {valores.preg19 &&
                valores.preg19.valor === 'Totalmente desacuerdo' && (
                  <span className="preg-red">20%</span>
                )}
            </td>
          </tr>
          <tr>
            <td>20. Motivación para daŕ la milla extra.</td>
            <td>
              {valores.preg20 &&
                valores.preg20.valor === 'Totalmente De acuerdo' && (
                  <span className="preg-green">100%</span>
                )}
              {valores.preg20 &&
                valores.preg20.valor === 'De acuerdo' && (
                  <span className="preg-blue">80%</span>
                )}
              {valores.preg20 &&
                valores.preg20.valor === 'Ni de acuerdo ni en desacuerdo' && (
                  <span className="preg-yellow">60%</span>
                )}
              {valores.preg20 &&
                valores.preg20.valor === 'En desacuerdo' && (
                  <span className="preg-orange">40%</span>
                )}
              {valores.preg20 &&
                valores.preg20.valor === 'Totalmente desacuerdo' && (
                  <span className="preg-red">20%</span>
                )}
            </td>
          </tr>
          <tr>
            <td>21. Entusiasmo y pasión por mi trabajo.</td>
            <td>
              {valores.preg21 &&
                valores.preg21.valor === 'Totalmente De acuerdo' && (
                  <span className="preg-green">100%</span>
                )}
              {valores.preg21 &&
                valores.preg21.valor === 'De acuerdo' && (
                  <span className="preg-blue">80%</span>
                )}
              {valores.preg21 &&
                valores.preg21.valor === 'Ni de acuerdo ni en desacuerdo' && (
                  <span className="preg-yellow">60%</span>
                )}
              {valores.preg21 &&
                valores.preg21.valor === 'En desacuerdo' && (
                  <span className="preg-orange">40%</span>
                )}
              {valores.preg21 &&
                valores.preg21.valor === 'Totalmente desacuerdo' && (
                  <span className="preg-red">20%</span>
                )}
            </td>
          </tr>
          <tr>
            <td>
              22. Mi trabajo que realizo beneficia la vida de mis clientes.
            </td>
            <td>
              {valores.preg22 &&
                valores.preg22.valor === 'Totalmente De acuerdo' && (
                  <span className="preg-green">100%</span>
                )}
              {valores.preg22 &&
                valores.preg22.valor === 'De acuerdo' && (
                  <span className="preg-blue">80%</span>
                )}
              {valores.preg22 &&
                valores.preg22.valor === 'Ni de acuerdo ni en desacuerdo' && (
                  <span className="preg-yellow">60%</span>
                )}
              {valores.preg22 &&
                valores.preg22.valor === 'En desacuerdo' && (
                  <span className="preg-orange">40%</span>
                )}
              {valores.preg22 &&
                valores.preg22.valor === 'Totalmente desacuerdo' && (
                  <span className="preg-red">20%</span>
                )}
            </td>
          </tr>
          <tr>
            <td>23. Balance entre el trabajo y la vida personal.</td>
            <td>
              {valores.preg23 &&
                valores.preg23.valor === 'Totalmente De acuerdo' && (
                  <span className="preg-green">100%</span>
                )}
              {valores.preg23 &&
                valores.preg23.valor === 'De acuerdo' && (
                  <span className="preg-blue">80%</span>
                )}
              {valores.preg23 &&
                valores.preg23.valor === 'Ni de acuerdo ni en desacuerdo' && (
                  <span className="preg-yellow">60%</span>
                )}
              {valores.preg23 &&
                valores.preg23.valor === 'En desacuerdo' && (
                  <span className="preg-orange">40%</span>
                )}
              {valores.preg23 &&
                valores.preg23.valor === 'Totalmente desacuerdo' && (
                  <span className="preg-red">20%</span>
                )}
            </td>
          </tr>
          <tr>
            <td>24. Cantidad de trabajo.</td>
            <td>
              {valores.preg24 &&
                valores.preg24.valor === 'Totalmente De acuerdo' && (
                  <span className="preg-green">100%</span>
                )}
              {valores.preg24 &&
                valores.preg24.valor === 'De acuerdo' && (
                  <span className="preg-blue">80%</span>
                )}
              {valores.preg24 &&
                valores.preg24.valor === 'Ni de acuerdo ni en desacuerdo' && (
                  <span className="preg-yellow">60%</span>
                )}
              {valores.preg24 &&
                valores.preg24.valor === 'En desacuerdo' && (
                  <span className="preg-orange">40%</span>
                )}
              {valores.preg24 &&
                valores.preg24.valor === 'Totalmente desacuerdo' && (
                  <span className="preg-red">20%</span>
                )}
            </td>
          </tr>
          <tr>
            <td>25. Herramientas, información y materiales a disposición.</td>
            <td>
              {valores.preg25 &&
                valores.preg25.valor === 'Totalmente De acuerdo' && (
                  <span className="preg-green">100%</span>
                )}
              {valores.preg25 &&
                valores.preg25.valor === 'De acuerdo' && (
                  <span className="preg-blue">80%</span>
                )}
              {valores.preg25 &&
                valores.preg25.valor === 'Ni de acuerdo ni en desacuerdo' && (
                  <span className="preg-yellow">60%</span>
                )}
              {valores.preg25 &&
                valores.preg25.valor === 'En desacuerdo' && (
                  <span className="preg-orange">40%</span>
                )}
              {valores.preg25 &&
                valores.preg25.valor === 'Totalmente desacuerdo' && (
                  <span className="preg-red">20%</span>
                )}
            </td>
          </tr>
          <tr>
            <td>26. Condiciones físicas del trabajo.</td>
            <td>
              {valores.preg26 &&
                valores.preg26.valor === 'Totalmente De acuerdo' && (
                  <span className="preg-green">100%</span>
                )}
              {valores.preg26 &&
                valores.preg26.valor === 'De acuerdo' && (
                  <span className="preg-blue">80%</span>
                )}
              {valores.preg26 &&
                valores.preg26.valor === 'Ni de acuerdo ni en desacuerdo' && (
                  <span className="preg-yellow">60%</span>
                )}
              {valores.preg26 &&
                valores.preg26.valor === 'En desacuerdo' && (
                  <span className="preg-orange">40%</span>
                )}
              {valores.preg26 &&
                valores.preg26.valor === 'Totalmente desacuerdo' && (
                  <span className="preg-red">20%</span>
                )}
            </td>
          </tr>
          <tr>
            <td>27. Apertura y flexibilidad hacia cambio.</td>
            <td>
              {valores.preg27 &&
                valores.preg27.valor === 'Totalmente De acuerdo' && (
                  <span className="preg-green">100%</span>
                )}
              {valores.preg27 &&
                valores.preg27.valor === 'De acuerdo' && (
                  <span className="preg-blue">80%</span>
                )}
              {valores.preg27 &&
                valores.preg27.valor === 'Ni de acuerdo ni en desacuerdo' && (
                  <span className="preg-yellow">60%</span>
                )}
              {valores.preg27 &&
                valores.preg27.valor === 'En desacuerdo' && (
                  <span className="preg-orange">40%</span>
                )}
              {valores.preg27 &&
                valores.preg27.valor === 'Totalmente desacuerdo' && (
                  <span className="preg-red">20%</span>
                )}
            </td>
          </tr>
          <tr>
            <td>28. Trabajo retador e interesante.</td>
            <td>
              {valores.preg28 &&
                valores.preg28.valor === 'Totalmente De acuerdo' && (
                  <span className="preg-green">100%</span>
                )}
              {valores.preg28 &&
                valores.preg28.valor === 'De acuerdo' && (
                  <span className="preg-blue">80%</span>
                )}
              {valores.preg28 &&
                valores.preg28.valor === 'Ni de acuerdo ni en desacuerdo' && (
                  <span className="preg-yellow">60%</span>
                )}
              {valores.preg28 &&
                valores.preg28.valor === 'En desacuerdo' && (
                  <span className="preg-orange">40%</span>
                )}
              {valores.preg28 &&
                valores.preg28.valor === 'Totalmente desacuerdo' && (
                  <span className="preg-red">20%</span>
                )}
            </td>
          </tr>
          <tr>
            <td>29. Evaluaciones de desempeño justas y apropiadas.</td>
            <td>
              {valores.preg29 &&
                valores.preg29.valor === 'Totalmente De acuerdo' && (
                  <span className="preg-green">100%</span>
                )}
              {valores.preg29 &&
                valores.preg29.valor === 'De acuerdo' && (
                  <span className="preg-blue">80%</span>
                )}
              {valores.preg29 &&
                valores.preg29.valor === 'Ni de acuerdo ni en desacuerdo' && (
                  <span className="preg-yellow">60%</span>
                )}
              {valores.preg29 &&
                valores.preg29.valor === 'En desacuerdo' && (
                  <span className="preg-orange">40%</span>
                )}
              {valores.preg29 &&
                valores.preg29.valor === 'Totalmente desacuerdo' && (
                  <span className="preg-red">20%</span>
                )}
            </td>
          </tr>
          <tr>
            <td>30. Hacer lo que mejor sé hacer en el trabajo.</td>
            <td>
              {valores.preg30 &&
                valores.preg30.valor === 'Totalmente De acuerdo' && (
                  <span className="preg-green">100%</span>
                )}
              {valores.preg30 &&
                valores.preg30.valor === 'De acuerdo' && (
                  <span className="preg-blue">80%</span>
                )}
              {valores.preg30 &&
                valores.preg30.valor === 'Ni de acuerdo ni en desacuerdo' && (
                  <span className="preg-yellow">60%</span>
                )}
              {valores.preg30 &&
                valores.preg30.valor === 'En desacuerdo' && (
                  <span className="preg-orange">40%</span>
                )}
              {valores.preg30 &&
                valores.preg30.valor === 'Totalmente desacuerdo' && (
                  <span className="preg-red">20%</span>
                )}
            </td>
          </tr>
          <tr>
            <td>31. Aprender nuevas habilidades.</td>
            <td>
              {valores.preg31 &&
                valores.preg31.valor === 'Totalmente De acuerdo' && (
                  <span className="preg-green">100%</span>
                )}
              {valores.preg31 &&
                valores.preg31.valor === 'De acuerdo' && (
                  <span className="preg-blue">80%</span>
                )}
              {valores.preg31 &&
                valores.preg31.valor === 'Ni de acuerdo ni en desacuerdo' && (
                  <span className="preg-yellow">60%</span>
                )}
              {valores.preg31 &&
                valores.preg31.valor === 'En desacuerdo' && (
                  <span className="preg-orange">40%</span>
                )}
              {valores.preg31 &&
                valores.preg31.valor === 'Totalmente desacuerdo' && (
                  <span className="preg-red">20%</span>
                )}
            </td>
          </tr>
          <tr>
            <td>32. Oportunidades para progresar.</td>
            <td>
              {valores.preg32 &&
                valores.preg32.valor === 'Totalmente De acuerdo' && (
                  <span className="preg-green">100%</span>
                )}
              {valores.preg32 &&
                valores.preg32.valor === 'De acuerdo' && (
                  <span className="preg-blue">80%</span>
                )}
              {valores.preg32 &&
                valores.preg32.valor === 'Ni de acuerdo ni en desacuerdo' && (
                  <span className="preg-yellow">60%</span>
                )}
              {valores.preg32 &&
                valores.preg32.valor === 'En desacuerdo' && (
                  <span className="preg-orange">40%</span>
                )}
              {valores.preg32 &&
                valores.preg32.valor === 'Totalmente desacuerdo' && (
                  <span className="preg-red">20%</span>
                )}
            </td>
          </tr>
          <tr>
            <td>33. Claridad acerca de lo que se espera de mi.</td>
            <td>
              {valores.preg33 &&
                valores.preg33.valor === 'Totalmente De acuerdo' && (
                  <span className="preg-green">100%</span>
                )}
              {valores.preg33 &&
                valores.preg33.valor === 'De acuerdo' && (
                  <span className="preg-blue">80%</span>
                )}
              {valores.preg33 &&
                valores.preg33.valor === 'Ni de acuerdo ni en desacuerdo' && (
                  <span className="preg-yellow">60%</span>
                )}
              {valores.preg33 &&
                valores.preg33.valor === 'En desacuerdo' && (
                  <span className="preg-orange">40%</span>
                )}
              {valores.preg33 &&
                valores.preg33.valor === 'Totalmente desacuerdo' && (
                  <span className="preg-red">20%</span>
                )}
            </td>
          </tr>
          <tr>
            <td>34. Salario justo.</td>
            <td>
              {valores.preg34 &&
                valores.preg34.valor === 'Totalmente De acuerdo' && (
                  <span className="preg-green">100%</span>
                )}
              {valores.preg34 &&
                valores.preg34.valor === 'De acuerdo' && (
                  <span className="preg-blue">80%</span>
                )}
              {valores.preg34 &&
                valores.preg34.valor === 'Ni de acuerdo ni en desacuerdo' && (
                  <span className="preg-yellow">60%</span>
                )}
              {valores.preg34 &&
                valores.preg34.valor === 'En desacuerdo' && (
                  <span className="preg-orange">40%</span>
                )}
              {valores.preg34 &&
                valores.preg34.valor === 'Totalmente desacuerdo' && (
                  <span className="preg-red">20%</span>
                )}
            </td>
          </tr>
          <tr>
            <td>35. Puedo ser yo mismo en el trabajo.</td>
            <td>
              {valores.preg35 &&
                valores.preg35.valor === 'Totalmente De acuerdo' && (
                  <span className="preg-green">100%</span>
                )}
              {valores.preg35 &&
                valores.preg35.valor === 'De acuerdo' && (
                  <span className="preg-blue">80%</span>
                )}
              {valores.preg35 &&
                valores.preg35.valor === 'Ni de acuerdo ni en desacuerdo' && (
                  <span className="preg-yellow">60%</span>
                )}
              {valores.preg35 &&
                valores.preg35.valor === 'En desacuerdo' && (
                  <span className="preg-orange">40%</span>
                )}
              {valores.preg35 &&
                valores.preg35.valor === 'Totalmente desacuerdo' && (
                  <span className="preg-red">20%</span>
                )}
            </td>
          </tr>
          <tr>
            <td>36. Transparencia y honestidad en esta organización.</td>
            <td>
              {valores.preg36 &&
                valores.preg36.valor === 'Totalmente De acuerdo' && (
                  <span className="preg-green">100%</span>
                )}
              {valores.preg36 &&
                valores.preg36.valor === 'De acuerdo' && (
                  <span className="preg-blue">80%</span>
                )}
              {valores.preg36 &&
                valores.preg36.valor === 'Ni de acuerdo ni en desacuerdo' && (
                  <span className="preg-yellow">60%</span>
                )}
              {valores.preg36 &&
                valores.preg36.valor === 'En desacuerdo' && (
                  <span className="preg-orange">40%</span>
                )}
              {valores.preg36 &&
                valores.preg36.valor === 'Totalmente desacuerdo' && (
                  <span className="preg-red">20%</span>
                )}
            </td>
          </tr>
          <tr>
            <td>37. Preocupación perder mi trabajo en los próximos seis meses.</td>
            <td>
              {valores.preg37 &&
                valores.preg37.valor === 'Totalmente De acuerdo' && (
                  <span className="preg-green">100%</span>
                )}
              {valores.preg37 &&
                valores.preg37.valor === 'De acuerdo' && (
                  <span className="preg-blue">80%</span>
                )}
              {valores.preg37 &&
                valores.preg37.valor === 'Ni de acuerdo ni en desacuerdo' && (
                  <span className="preg-yellow">60%</span>
                )}
              {valores.preg37 &&
                valores.preg37.valor === 'En desacuerdo' && (
                  <span className="preg-orange">40%</span>
                )}
              {valores.preg37 &&
                valores.preg37.valor === 'Totalmente desacuerdo' && (
                  <span className="preg-red">20%</span>
                )}
            </td>
          </tr>
          <tr>
            <td>38. Seguridad de mi trabajo, aún si cometo un error.</td>
            <td>
              {valores.preg38 &&
                valores.preg38.valor === 'Totalmente De acuerdo' && (
                  <span className="preg-green">100%</span>
                )}
              {valores.preg38 &&
                valores.preg38.valor === 'De acuerdo' && (
                  <span className="preg-blue">80%</span>
                )}
              {valores.preg38 &&
                valores.preg38.valor === 'Ni de acuerdo ni en desacuerdo' && (
                  <span className="preg-yellow">60%</span>
                )}
              {valores.preg38 &&
                valores.preg38.valor === 'En desacuerdo' && (
                  <span className="preg-orange">40%</span>
                )}
              {valores.preg38 &&
                valores.preg38.valor === 'Totalmente desacuerdo' && (
                  <span className="preg-red">20%</span>
                )}
            </td>
          </tr>
          <tr>
            <td>39. Desacuerdo con mi jefe sin temor a meterme en problemas.</td>
            <td>
              {valores.preg39 &&
                valores.preg39.valor === 'Totalmente De acuerdo' && (
                  <span className="preg-green">100%</span>
                )}
              {valores.preg39 &&
                valores.preg39.valor === 'De acuerdo' && (
                  <span className="preg-blue">80%</span>
                )}
              {valores.preg39 &&
                valores.preg39.valor === 'Ni de acuerdo ni en desacuerdo' && (
                  <span className="preg-yellow">60%</span>
                )}
              {valores.preg39 &&
                valores.preg39.valor === 'En desacuerdo' && (
                  <span className="preg-orange">40%</span>
                )}
              {valores.preg39 &&
                valores.preg39.valor === 'Totalmente desacuerdo' && (
                  <span className="preg-red">20%</span>
                )}
            </td>
          </tr>
          <tr>
            <td>40. Apoyo de otras personas.</td>
            <td>
              {valores.preg40 &&
                valores.preg40.valor === 'Totalmente De acuerdo' && (
                  <span className="preg-green">100%</span>
                )}
              {valores.preg40 &&
                valores.preg40.valor === 'De acuerdo' && (
                  <span className="preg-blue">80%</span>
                )}
              {valores.preg40 &&
                valores.preg40.valor === 'Ni de acuerdo ni en desacuerdo' && (
                  <span className="preg-yellow">60%</span>
                )}
              {valores.preg40 &&
                valores.preg40.valor === 'En desacuerdo' && (
                  <span className="preg-orange">40%</span>
                )}
              {valores.preg40 &&
                valores.preg40.valor === 'Totalmente desacuerdo' && (
                  <span className="preg-red">20%</span>
                )}
            </td>
          </tr>
          <tr>
            <td>41. Buenos amigos en el trabajo.</td>
            <td>
              {valores.preg41 &&
                valores.preg41.valor === 'Totalmente De acuerdo' && (
                  <span className="preg-green">100%</span>
                )}
              {valores.preg41 &&
                valores.preg41.valor === 'De acuerdo' && (
                  <span className="preg-blue">80%</span>
                )}
              {valores.preg41 &&
                valores.preg41.valor === 'Ni de acuerdo ni en desacuerdo' && (
                  <span className="preg-yellow">60%</span>
                )}
              {valores.preg41 &&
                valores.preg41.valor === 'En desacuerdo' && (
                  <span className="preg-orange">40%</span>
                )}
              {valores.preg41 &&
                valores.preg41.valor === 'Totalmente desacuerdo' && (
                  <span className="preg-red">20%</span>
                )}
            </td>
          </tr>
          <tr>
            <td>42. Compañeros de trabajo se preocupan por mí.</td>
            <td>
              {valores.preg42 &&
                valores.preg42.valor === 'Totalmente De acuerdo' && (
                  <span className="preg-green">100%</span>
                )}
              {valores.preg42 &&
                valores.preg42.valor === 'De acuerdo' && (
                  <span className="preg-blue">80%</span>
                )}
              {valores.preg42 &&
                valores.preg42.valor === 'Ni de acuerdo ni en desacuerdo' && (
                  <span className="preg-yellow">60%</span>
                )}
              {valores.preg42 &&
                valores.preg42.valor === 'En desacuerdo' && (
                  <span className="preg-orange">40%</span>
                )}
              {valores.preg42 &&
                valores.preg42.valor === 'Totalmente desacuerdo' && (
                  <span className="preg-red">20%</span>
                )}
            </td>
          </tr>
          <tr>
            <td>43. Celebramos nuestros éxitos.</td>
            <td>
              {valores.preg43 &&
                valores.preg43.valor === 'Totalmente De acuerdo' && (
                  <span className="preg-green">100%</span>
                )}
              {valores.preg43 &&
                valores.preg43.valor === 'De acuerdo' && (
                  <span className="preg-blue">80%</span>
                )}
              {valores.preg43 &&
                valores.preg43.valor === 'Ni de acuerdo ni en desacuerdo' && (
                  <span className="preg-yellow">60%</span>
                )}
              {valores.preg43 &&
                valores.preg43.valor === 'En desacuerdo' && (
                  <span className="preg-orange">40%</span>
                )}
              {valores.preg43 &&
                valores.preg43.valor === 'Totalmente desacuerdo' && (
                  <span className="preg-red">20%</span>
                )}
            </td>
          </tr>
          <tr>
            <td>44. Relación con mis compañeros de trabajo.</td>
            <td>
              {valores.preg44 &&
                valores.preg44.valor === 'Totalmente De acuerdo' && (
                  <span className="preg-green">100%</span>
                )}
              {valores.preg44 &&
                valores.preg44.valor === 'De acuerdo' && (
                  <span className="preg-blue">80%</span>
                )}
              {valores.preg44 &&
                valores.preg44.valor === 'Ni de acuerdo ni en desacuerdo' && (
                  <span className="preg-yellow">60%</span>
                )}
              {valores.preg44 &&
                valores.preg44.valor === 'En desacuerdo' && (
                  <span className="preg-orange">40%</span>
                )}
              {valores.preg44 &&
                valores.preg44.valor === 'Totalmente desacuerdo' && (
                  <span className="preg-red">20%</span>
                )}
            </td>
          </tr>
          <tr>
            <td>45. Sensación de trabajo en equipo y cooperación en mi empresa.</td>
            <td>
              {valores.preg45 &&
                valores.preg45.valor === 'Totalmente De acuerdo' && (
                  <span className="preg-green">100%</span>
                )}
              {valores.preg45 &&
                valores.preg45.valor === 'De acuerdo' && (
                  <span className="preg-blue">80%</span>
                )}
              {valores.preg45 &&
                valores.preg45.valor === 'Ni de acuerdo ni en desacuerdo' && (
                  <span className="preg-yellow">60%</span>
                )}
              {valores.preg45 &&
                valores.preg45.valor === 'En desacuerdo' && (
                  <span className="preg-orange">40%</span>
                )}
              {valores.preg45 &&
                valores.preg45.valor === 'Totalmente desacuerdo' && (
                  <span className="preg-red">20%</span>
                )}
            </td>
          </tr>
          <tr>
            <td>46. Disfruto trabajando en el equipo.</td>
            <td>
              {valores.preg46 &&
                valores.preg46.valor === 'Totalmente De acuerdo' && (
                  <span className="preg-green">100%</span>
                )}
              {valores.preg46 &&
                valores.preg46.valor === 'De acuerdo' && (
                  <span className="preg-blue">80%</span>
                )}
              {valores.preg46 &&
                valores.preg46.valor === 'Ni de acuerdo ni en desacuerdo' && (
                  <span className="preg-yellow">60%</span>
                )}
              {valores.preg46 &&
                valores.preg46.valor === 'En desacuerdo' && (
                  <span className="preg-orange">40%</span>
                )}
              {valores.preg46 &&
                valores.preg46.valor === 'Totalmente desacuerdo' && (
                  <span className="preg-red">20%</span>
                )}
            </td>
          </tr>
          <tr>
            <td>47. Me siento escuchado.</td>
            <td>
              {valores.preg47 &&
                valores.preg47.valor === 'Totalmente De acuerdo' && (
                  <span className="preg-green">100%</span>
                )}
              {valores.preg47 &&
                valores.preg47.valor === 'De acuerdo' && (
                  <span className="preg-blue">80%</span>
                )}
              {valores.preg47 &&
                valores.preg47.valor === 'Ni de acuerdo ni en desacuerdo' && (
                  <span className="preg-yellow">60%</span>
                )}
              {valores.preg47 &&
                valores.preg47.valor === 'En desacuerdo' && (
                  <span className="preg-orange">40%</span>
                )}
              {valores.preg47 &&
                valores.preg47.valor === 'Totalmente desacuerdo' && (
                  <span className="preg-red">20%</span>
                )}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/pages/survey/Detallado.jsx